import Entity from '../entity';
import FlightClass from './flightClass';
import FlightSegment from './flightSegment';

export default class FlightQuota extends Entity<string> {
  flightPriceId: string;
  quota: number;
  remainingQuota: number;
  isGroup: boolean;
  isDeleted: boolean;
  deleterUserId: any;
  deletionTime: any;
  lastModificationTime: string;
  lastModifierUserId: number;
  creationTime: string;
  creatorUserId: number;
  flightSegment: FlightSegment;
  flightClass: FlightClass;
}
